import * as React from 'react'
import styled from '@emotion/styled'
//import { SocialIcon } from 'react-social-icons';
//import BookingDates, {Dates} from "../BookingDates";
//import Lightbox from 'lightbox-react';
import { GoChevronDown } from "react-icons/go";
//import ReadMore from '@crossfield/react-read-more'
import ReadMoreTwo from './../../react-read-more-2'
import 'lightbox-react/style.css';
//import StudioLightbox from "./StudioLightbox";
import { FormattedMessage } from 'react-intl';
import {fonts} from "../../../styles/variables";
//import { GiInfo } from "react-icons/gi";
import {MdBurstMode, MdChromeReaderMode, MdOpenInNew, MdDetails} from "react-icons/md";
const genderNeutral = require('../../../../assets/images/svg/gender_neutral.svg');

import {SlideDown} from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'
import {
  StudioImg1, StudioImg10, StudioImg11, StudioImg12,
  StudioImg2,
  StudioImg3,
  StudioImg4,
  StudioImg5,
  StudioImg6, StudioImg7, StudioImg8, StudioImg9,
  StudioThumb
} from './StudioImg'
import SimpleReactLightbox from 'simple-react-lightbox'
import { IoTriangleOutline } from 'react-icons/io5'
import Lightbox from 'lightbox-react'

const lightboxImg = [
  <StudioImg1/>,
  <StudioImg2/>,
  <StudioImg3/>,
  <StudioImg4/>,
  <StudioImg5/>,
  <StudioImg6/>,
  <StudioImg7/>,
  <StudioImg8/>,
  <StudioImg9/>,
  <StudioImg10/>,
  <StudioImg11/>,
  <StudioImg12/>]
const LightboxProvider = styled(SimpleReactLightbox)`
z-index:99999999999;

#SRLLightbox{

z-index:99999999999;
}

`
const StyledSlideDown = styled(SlideDown)`
//padding-left:50px;

@media screen and (max-width:1200px){
padding-left:0px  ;

}
`

const GenderNeutral: any = styled.img`
height:30px;
width:20px;
opacity:.1;

   @media screen and (max-width: 600px) {
height:20px;
width:20px;
}
`

const ListIcon = styled(IoTriangleOutline)`
font-size: 10px !important;
margin-right:0.3rem;

 transform: rotate(180deg);

`

const HighBox = styled.div`
border: 1px solid #8AD1A9;
border-radius:3px;
color:#8AD1A9;
font-size:12px;
width:auto;
text-transform:uppercase;
 font-family:${fonts.engraversBold};
 font-weight:bold;
margin-top: 7px;
padding: 1px 5px;
margin-right: 3px;
margin-left: 1px;




`

const HighBox_2 = styled.div`
border: 1px solid #8AD1A9;
border-radius:3px;
color:#8AD1A9;
font-size:12px;
width:auto;
text-transform:uppercase;
 font-family:${fonts.engraversBold};
 font-weight:bold;
 margin-right:30px;
padding: 1px 5px;
margin-left: 1px;




`


const Img = styled.img`
width:auto;
cursor:pointer;
height:220px;
border-radius:2px;
display:block;
margin:0;
opacity:0.8;
transition: all .7s ease;
:hover{
opacity:1;
}


`



const InfoButton = styled.div`

//margin-right:2%;
 cursor:pointer;
font-weight:700;
height:40px;
//border-top:2px solid  rgba(84, 170, 241,.1);
border-radius:10rem;
width:49%;
 display: flex;
 align-items:center;
 justify-content:center;
 // border-radius: 10rem;
  color: rgb(68,68,68,.5);
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;

font-family:${fonts.button};
letter-spacing:2px;


:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: rgba(84, 170, 241,.2);
  transition: all .3s;
 // border-radius: 10rem;
  z-index: -1;


}

 :after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(84, 170, 241,.3);
  //border-radius: 10rem;
  z-index: -2;

}

:hover {
  color: rgb(68,68,68);
}

:hover:before {
  height: 100%;

}


   @media screen and (max-width: 1295px) {
//z-index:999999;
}

`
const InfoButtonActive = styled.div`

//margin-right:2%;
 cursor:pointer;
font-weight:700;
height:40px;
border-top:2px solid  rgba(84, 170, 241,.1);
border-radius:10rem;

width:49%;
 display: flex;
 align-items:center;
 justify-content:center;
 // border-radius: 10rem;
  color: white;
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;

font-family:${fonts.button};
letter-spacing:2px;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: #54aaf1;
  transition: all .3s;
 // border-radius: 10rem;
  z-index: -1;


}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #188cec;
  //border-radius: 10rem;
  z-index: -2;

}

:hover {
}

:hover:before {
  height: 100%;

}


   @media screen and (max-width: 1295px) {
//z-index:999999;
}

`
const BtnDiv = styled.div`
height:45%;
display:flex;
justify-content:space-between;
margin-left:10%;
margin-right:32px;
padding-bottom:2%;
padding-top:2%;
  @media screen and (max-width: 600px) {
  display:none;
  height:100%;
  }


`
const ReadMoreButtonTwo = styled.div`
 display: flex;
align-items: center;
justify-content:center;
width:100%;
height:40px;
border-radius:2px;
border-left:1px solid lightgrey;
border-right:1px solid lightgrey;
border-top:1px solid lightgrey;
border-bottom:1px solid lightgrey;
transition: all .7s ease;
cursor:pointer;
letter-spacing:1px;
font-weight:bold;
font-size:19px;

  @media screen and (max-width: 666px) {
border-top:1px solid lightgrey;
   }



:hover{
background: rgba(68,68,68,.2);
//letter-spacing:0px;



}
`



const Div = styled.div`
width:100%;

display:flex;

  @media screen and (max-width: 666px) {
  display:block;
  height:auto;
  }
`

const Div2 = styled.div`
width:34%;
min-width:150px;

`


const Outer = styled.div`



 font-family: "Theano Didot",Regular;
width:100%;
border-left:1px solid rgba(68,68,68,.04);
border-right:1px solid rgba(68,68,68,.04);
border-top:1px solid rgba(68,68,68,.04);
border-bottom:1px solid rgba(68,68,68,.04);
//box-shadow: 1px 2px 4px rgba(0,0,0,.1);
border-radius:2px;
height:auto;
-webkit-border-radius: 2px;
-moz-border-radius: 2px;
border-radius: 2px;


transition: all .3s ease;
:hover{
// box-shadow: 0 17.125px 50px -12.125px rgba(0,0,0,0.3);

 ${Img}{

opacity:1;
}
}
 `




const GreenOuter = styled.div`




margin-top:40px;
//border: 4px solid rgb(76, 175, 80);
height:auto;
-webkit-border-radius: 2px;
-moz-border-radius: 2px;
border-radius:2px;

 `


const Left = styled.div`
width:51%;
display:block;
border-right: 1px solid rgba(68,68,68,.04);


`

const InfoLeft = styled.div`
width:34%;
height:0px;
display:flex;
  flex-wrap: wrap;

  border-right: 1px solid rgba(68,68,68,.04);


`



const InfoRight = styled.div`
letter-spacing:0.6px;
padding-top:11px;
font-size:13px;
 font-family:${fonts.engraversBold};
text-transform:uppercase;
width:66%;
text-align:left !important;

display:block;

  @media screen and (max-width: 666px) {  }


`

const StyledP = styled.p`
 font-family: "Theano Didot",Regular;
font-style: italic;
font-size: 180%;
line-height: 40px;
letter-spacing: 2px;
color:rgb(68, 68, 68);
margin-bottom:0;
//margin-top:10px;
text-align:left !important;
  @media screen and (max-width: 460px) {
  font-size: 130%;
letter-spacing: 0px;
//display:none;
   }


`;

const StyledPMobile = styled.p`
 font-family: "Theano Didot",Regular;
font-style: italic;
font-size: 120%;
line-height: 40px;
letter-spacing: 0px;
color:rgb(68, 68, 68);
margin-left:auto;
margin-right:auto;
margin-bottom:0px !important;
text-align:center !important;
display:none;


 @media screen and (max-width: 666px) {
display:none;
   }


`;

const A = styled.a`
`



const ShareButton = styled.div`
 display: flex;
align-items: center;
justify-content:center;width:330px;
height:50px;
border-radius:2px;
border-left:1px solid lightgrey;
border-right:1px solid lightgrey;
border-top:1px solid lightgrey;
border-bottom:1px solid lightgrey;
transition: all .7s ease;
cursor:pointer;
letter-spacing:1px;
font-weight:bold;

 @media screen and (max-width: 666px) {
display:none;
   }



:hover{
background: rgba(68,68,68,.2);
//letter-spacing:0px;



}
`

const MobileShareButton = styled.div`
 display: flex;
align-items: center;
justify-content:center;width:330px;
height:50px;
border-radius:2px;
border-left:1px solid lightgrey;
border-right:1px solid lightgrey;
border-top:1px solid lightgrey;
border-bottom:1px solid lightgrey;
transition: all .7s ease;
cursor:pointer;
letter-spacing:1px;
font-weight:bold;
display:none;


 @media screen and (max-width: 666px) {
display:block;
   }



:hover{
background: rgba(68,68,68,.2);
//letter-spacing:0px;



}
`


const ChooseButton = styled.div`
text-align:center;
width:100%;
height:50px;
border-radius:2px;
cursor:pointer;
letter-spacing:1px;
font-weight:bold;
font-size:19px;
border-top: 1px solid lightgrey;
//border-bottom: 1px solid lightgrey;
//border-left: 1px solid lightgrey;
//border-right: 1px solid lightgrey;
 display: flex;
align-items: center;
justify-content:center;
transition: all .7s ease;
background:rgb(24, 140, 236);
color:white;


:hover{
//color:white;
background:#188cec;
//letter-spacing:0px;
}
`

const SelectedChooseButton = styled.div`
text-align:center;
width:100%;
height:50px;
border-radius:2px;
cursor:pointer;
letter-spacing:1px;
font-weight:bold;
font-size:19px;
border-top: 1px solid lightgrey;
//border-bottom: 1px solid lightgrey;
//border-left: 1px solid lightgrey;
//border-right: 1px solid lightgrey;
 display: flex;
align-items: center;
justify-content:center;
transition: all .7s ease;


`

const CheckIcon = styled.div`
color:white;
padding-left:10px;
`

const ReadMoreMobile = styled.div`

ul{
padding-top:15px;
padding-bottom:15px;
}


width: 0px !important;
height: 0px !important;
opacity:0;
 @media screen and (max-width: 666px) {
//width: auto !important;
//height: auto !important;
//opacity:1;
   }
`

const ReadMoreDiv = styled.div`
width: auto !important;
height: auto !important;
opacity:1;

.readmore.container{
padding-right:0.5rem;
}









 @media screen and (max-width: 666px) {
width: 0px !important;
height: 0px !important;
opacity:0;

}

`

const Topper = styled.div`
display:flex;



`

const InfoTopper = styled.div`
padding-top:5px;
display:flex;
padding-bottom:25px;
background: rgba(68,68,68,.02);
border:1px solid rgba(68,68,68,.04);
border-radius:2px;

  @media screen and (max-width: 590px) {
display:none;  }



`


const Right = styled.div`
width:66%;
display:block;

  @media screen and (max-width: 666px) {  }

`

const PDiv = styled.div`
height:55%;
align-items:center;
display:flex;
justify-content:space-between;
cursor:pointer;
title:'Auswählen';
//border-right:1px solid lightgrey;;
//border-bottom:1px solid lightgrey;
transition:all 0.3s;
background:rgba(68,68,68,0.01);





:hover{
background:rgba(68,68,68,0.02);
${StyledP}{
color:black;
}

.btn-radio svg circle{
stroke-width:1.6;
}
}

  @media screen and (max-width: 600px) {
height:100%;   }


`

const Capacity = styled.div`
width:auto;
display:flex;
justify-content:space-between;
align-items:center;

  @media screen and (max-width: 450px) {
  display:none;
   }
`



const RadioGroupWrapper = styled.div`
margin-right:32px;

.btn-radio {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  display:flex;
  align-items:center;
   padding-left:15px;
   height:70px;

}
.btn-radio:not(:first-child) {
  margin-left: 20px;
}

label:nth-child(2) {
  border-bottom:none !important;
}

@media screen and (max-width: 460px) {
margin-right:3%;

  .btn-radio {

justify-content:space-between;
padding-right:10px;
  }
  .btn-radio:not(:first-child) {
    margin-left: 0;
  }
}
.btn-radio svg {
  fill: none;
  vertical-align: middle;
}
.btn-radio svg circle {
  stroke-width: 1.3;
  stroke:rgb(68, 68, 68);
}
.btn-radio svg path {
  stroke: rgb(24, 140, 236);
}
.btn-radio svg path.inner {
  stroke-width: 6;
  stroke-dasharray: 19;
  stroke-dashoffset: 19;
}
.btn-radio svg path.outer {
  stroke-width: 2;
  stroke-dasharray: 57;
  stroke-dashoffset: 57;
}
.btn-radio input {
  display: none;
}
.btn-radio input:checked + svg path {
  transition: all 0.1s ease;
}
.btn-radio input:checked + svg path.inner {
  stroke-dashoffset: 38;
  transition-delay: 0.05s;
}



.btn-radio input:checked + svg path.outer {
  stroke-dashoffset: 0;
}










.btn-radio{
width:100%;
}

`

const InfoFlex = styled.div`
padding-left:10%;

display:flex;
align-items:center;
`

const RadioDiv = styled.div`

height:70px;
display:flex;
align-items:center;

@media screen and (max-width:460px){
height:auto;

}

`

const PriceLabel = styled.div`
display:flex;
flex-direction:row-reverse;
`

const PriceLabel_2 = styled.div`
display:flex;
flex-direction:row-reverse;
align-items:flex-start;
`

const StrikeTrough = styled.div`
  position: relative;
   font-family: "Theano Didot",Regular;

  font-size:16px;
  padding-right:35px;
 // padding-bottom:5px;
:before {
  position: absolute;
  content: "";
  left: -5px;
  top: 36%;
  right: 30px;
  border-top: 2px solid ;
  border-color: #54aaf1;

  -webkit-transform:rotate(-7deg);
  -moz-transform:rotate(-7deg);
  -ms-transform:rotate(-7deg);
  -o-transform:rotate(-7deg);
  transform:rotate(-7deg);
}
`


const PPN = styled.div`
 font-family: "Theano Didot",Regular;

  font-size:16px;
  padding-right:35px;
  padding-bottom:5px;
`

const SelectEmpty = styled.div`
height:20px;
width:20px;
border-radius:20px;
border:1px solid rgb(68,68,68);
`


const OpenPhotos = styled.div`

//margin-right:2%;
 cursor:pointer;
font-weight:700;
height:40px;
//border-top:1px solid rgba(68,68,68,.04);;
border-radius:10rem;
//border-right:2px solid  rgba(84, 170, 241,.1);
//border-top:2px solid  rgba(84, 170, 241,.1);
width:49%;
 display: flex;
 align-items:center;
 justify-content:center;
 // border-radius: 10rem;
  color: rgb(68,68,68,.5);
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;

font-family:${fonts.button};
letter-spacing:2px;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: rgba(84, 170, 241,.2);
  transition: all .3s;
 // border-radius: 10rem;
  z-index: -1;
}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color:rgba(84, 170, 241,.3) ;
 // border-radius: 10rem;
  z-index: -2;
}

:hover {
  color: rgb(68,68,68);
}

:hover:before {
  width: 100%;
}


   @media screen and (max-width: 1295px) {
//z-index:999;
}

`

const LightboxWrapper = styled.div`



`

export class Studio extends React.Component<any,any> {
  constructor (props) {
    super(props)
    const availableStudios = props.availableStudios;
    const availableRooms = props.availableRooms;
    this.state = {
      isOpen:false,
      photosOpen:false,
      photoIndex: 0,
      category:0,
      selectBlock:this.props.selectBlock,
      isSelected: this.props.isSelected,
      selectText: !this.props.isSelected ? 'Select' : 'Selected',
      background: !this.props.isSelected ? 'rgb(24, 140, 236)' : 'rgb(102, 163, 102)',
      color:!this.props.isSelected ? 'white' : 'white',
      displayCheckMark:!this.props.isSelected ? 'none' : 'block',
      infoClosed:true
    }

    this.handleSelection = this.handleSelection.bind(this)
    this.openPhotos= this.openPhotos.bind(this)
    this.closePhotos= this.closePhotos.bind(this)
    this.openSlide= this.openSlide.bind(this)
    this.closeSlide= this.closeSlide.bind(this)
    this.toggleInfo = this.toggleInfo.bind(this)
  }


toggleInfo(){
    this.setState({
      infoClosed:!this.state.infoClosed
    })
}

  handleSelection(){
    this.props.handler(this.state.category, this.state.selectBlock );
    this.setState({
      isSelected:!this.state.isSelected,
      selectText:this.state.isSelected ? 'Select' : 'Selected',
      background: this.state.isSelected ? 'rgb(24, 140, 236)' : 'rgb(102, 163, 102)',
      color:this.state.isSelected ? 'white' : 'white',
      displayCheckMark:this.state.isSelected ? 'none' : 'block'

    })
  }


  componentWillReceiveProps(nextProps) {
    if(!nextProps.isSelected) {
      this.setState({
        isSelected:nextProps.isSelected,
        selectText:'Select',
        background: 'rgb(24, 140, 236)',
        color:'white',
        displayCheckMark:'none'

      })    }
  }

  openPhotos(){
    this.setState({
      photosOpen: true })
  }

  closePhotos(){
    this.setState({
      photosOpen: false })
  }

  openSlide(){
    this.setState({
      isOpen: true })
  }

    closeSlide(){
    this.setState({ isOpen: false })}




  render () {
    return (
      <GreenOuter >
        <Outer>
          <Topper>
            <Div2 onClick={()=>this.openPhotos()} >
              <div>

                <StudioThumb />

                {this.state.photosOpen && (
                  <LightboxWrapper>
                    <Lightbox
                      enableZoom={false}
                      mainSrc={lightboxImg[this.state.photoIndex]}
                      nextSrc={lightboxImg[(this.state.photoIndex + 1) % lightboxImg.length]}
                      prevSrc={lightboxImg[(this.state.photoIndex + lightboxImg.length - 1) % lightboxImg.length]}
                      onCloseRequest={() => this.closePhotos()}
                      onMovePrevRequest={() =>
                        this.setState({
                          photoIndex: (this.state.photoIndex + lightboxImg.length - 1) % lightboxImg.length,
                        })
                      }
                      onMoveNextRequest={() =>
                        this.setState({
                          photoIndex: (this.state.photoIndex + 1) % lightboxImg.length,
                        })
                      }
                    />
                  </LightboxWrapper>
                )}



              </div>
            </Div2>            <Right>
              <PDiv onClick={this.handleSelection}>
                <div  style={{display:'flex', marginLeft:'10%'}}>
                  <StyledP>Studio</StyledP>
                  <Capacity>
                    <GenderNeutral src={genderNeutral}/>
                    <GenderNeutral src={genderNeutral} />

                  </Capacity>
                </div>

                <RadioGroupWrapper className={"cntr-"+this.state.selectBlock}>
                  {!this.state.isSelected &&
                  <RadioDiv><SelectEmpty></SelectEmpty></RadioDiv>
                  }
                  {this.state.isSelected &&
                  <div >
                    <label htmlFor={"rdo-"+this.state.selectBlock}  className="btn-radio">
                      <RadioDiv  style={{color:this.state.isSelected ? 'rgb(24, 140, 236)':'rgb(68,68,68)'}} >
                        <input onClick={this.handleSelection} checked={this.state.isSelected}   type="radio" id={"rdo-"+this.state.selectBlock} name={"radio-grp-"+this.state.selectBlock}/>
                        <svg width="20px" height="20px" viewBox="0 0 20 20">
                          <circle cx="10" cy="10" r="9"></circle>
                          <path
                            d="M10,7 C8.34314575,7 7,8.34314575 7,10 C7,11.6568542 8.34314575,13 10,13 C11.6568542,13 13,11.6568542 13,10 C13,8.34314575 11.6568542,7 10,7 Z"
                            className="inner"></path>
                          <path
                            d="M10,1 L10,1 L10,1 C14.9705627,1 19,5.02943725 19,10 L19,10 L19,10 C19,14.9705627 14.9705627,19 10,19 L10,19 L10,19 C5.02943725,19 1,14.9705627 1,10 L1,10 L1,10 C1,5.02943725 5.02943725,1 10,1 L10,1 Z"
                            className="outer"></path>
                        </svg>
                      </RadioDiv>



                    </label>
                  </div>
                  }

                </RadioGroupWrapper>
              </PDiv>
              <BtnDiv>
                <OpenPhotos title={'Photos'} onClick={()=> this.setState({photosOpen:true})}>
                  <MdBurstMode/>
                </OpenPhotos>             <InfoButton style={{display: this.state.infoClosed ? 'flex':'none'}} onClick={this.toggleInfo} title={'Info'}><MdChromeReaderMode/></InfoButton>
                <InfoButtonActive style={{display: this.state.infoClosed ? 'none':'flex'}} onClick={this.toggleInfo} title={'Info'}><MdChromeReaderMode/> </InfoButtonActive>

              </BtnDiv>
            </Right>
          </Topper>
          <Div>

            <Left>
              <StyledPMobile>Studio</StyledPMobile>




            </Left>
            <Right>
                <ReadMoreMobile>
                  <ReadMoreTwo
                    initialHeight={0}
                    readMore={props => (
                      <ReadMoreButtonTwo style={{width: '100%'}} onClick={props.onClick}>
                        {props.open ? 'Read less' : 'Read more'}
                        <GoChevronDown
                          name="caret"
                          style={{
                            transform: `rotate( ${props.open ? '180deg' : '0deg'})`,
                            transition: 'transform 0.25s',
                          }}
                        />
                      </ReadMoreButtonTwo>
                    )}
                  >

                    <ul>
                      <li>Studio for 1 - 2 people</li>
                      <li>bed room and living room</li>
                      <li>with single or double beds</li>
                      <li>boxspringbeds for high sleeping comfort</li>
                      <li>3. person sleeps on a comfortable sofa</li>
                      <li>fauteuil or armchair</li>
                      <li>bathroom with shower or bath, hairdryer, Aesop cosmetic products</li>
                      <li>Minibar with all amenities for free coffee and tea, mini-refridgerator with ice cube tray</li>
                      <li>  free TV and High Speed WiFi</li>
                    </ul>

                  </ReadMoreTwo>
                </ReadMoreMobile>
              <ReadMoreDiv>


              </ReadMoreDiv>
            </Right>

          </Div>

     </Outer>
        <StyledSlideDown closed={this.state.infoClosed} className={'css-2289437'}>
          <InfoTopper>
            <InfoLeft>

              <HighBox><FormattedMessage id={'info_text_1'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_2'}/></HighBox>
              <HighBox>TV</HighBox>
              <HighBox><FormattedMessage id={'info_text_3'}/></HighBox>

              <HighBox><FormattedMessage id={'info_text_4'}/></HighBox>
              <HighBox>SHUTTLE SERVICE</HighBox>
              <HighBox>LATE CHECK-IN</HighBox>

            </InfoLeft>
            <InfoRight>

              <InfoFlex><ListIcon/> <FormattedMessage id={'studio_text_3'}/></InfoFlex>
              <InfoFlex><ListIcon/> <FormattedMessage id={'studio_text_4'}/></InfoFlex>
              <InfoFlex><ListIcon/> <FormattedMessage id={'studio_text_5'}/></InfoFlex>
              <InfoFlex><ListIcon/> <FormattedMessage id={'info_text_5'}/></InfoFlex>
              <InfoFlex><ListIcon/> <FormattedMessage id={'info_text_6'}/></InfoFlex>
              <InfoFlex><ListIcon/> <FormattedMessage id={'info_text_7'}/></InfoFlex>
              <InfoFlex><ListIcon/> <FormattedMessage id={'info_text_8'}/></InfoFlex>
              <InfoFlex><ListIcon/> <FormattedMessage id={'studio_text_9'}/></InfoFlex>


            </InfoRight>
          </InfoTopper>
        </StyledSlideDown>
      </GreenOuter>
    )
  }
}


/*

      <PriceLabel> <StrikeTrough>{Math.ceil(((107*this.props.price)/100)/this.props.nights)}€</StrikeTrough></PriceLabel>
              <PriceLabel_2><PPN>{Math.ceil(this.props.price/this.props.nights)}€</PPN>               <HighBox_2><FormattedMessage id={'info_text_9'}/></HighBox_2>
              </PriceLabel_2>
 */
